import { createApiSlice } from 'app/createApiSlice'

export const annualCapacityApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'annualCapacity/api',
  endpoints(builder) {
    return {
      fetchAnnualCapacity: builder.query({
        query({ year }) {
          return {
            url: '/api/v1/bussines/compliance/capacitychart/all',
            params: {
              year,
            },
          }
        },
      }),
    }
  },
})

export const { useFetchAnnualCapacityQuery, useLazyFetchAnnualCapacityQuery } =
  annualCapacityApiSlice
